<template>
  <div class="honorSwipe" style="width:100%;height:100%">
    <div v-if="windowWidth > 767">
      <swiper
        class="mySwipe"
        :options="swiperOption"
        ref="videoSwiper"
        style=" height: 100%; margin: 50px auto; padding: 100px 0;transform: scale(0.8)"
      >
        <swiper-slide>
          <div class="honorBOx">
            <div>
              <img src="@/assets/images/aboutUs/honor/2018中国CFO最佳财务共享服务奖.jpg" alt="" />
            </div>
            <div class="honorBOx_title">2018中国CFO最佳财务共享服务奖</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div>
              <img src="@/assets/images/aboutUs/honor/2018中国CFO最佳财务共享服务奖.jpg" alt="" />
            </div>
            <div class="honorBOx_title">2018中国CFO最佳财务共享服务奖</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2021中国领先地智慧企业云平台.jpg" alt="" />
            </div>
            <div class="honorBOx_title">2021中国领先地智慧企业云平台</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/国旅感谢信.jpg" alt="" />
            </div>
            <div class="honorBOx_title">国旅感谢信</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2019中国企业财务共享平台首选品牌厂商奖.png" alt="" />
            </div>
            <div class="honorBOx_title">2019中国企业财务共享平台首选品牌厂商奖</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/CMMI3认证证书.png" alt="" />
            </div>
            <div class="honorBOx_title">CMMI3认证证书</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/ISO9001.png" alt="" />
            </div>
            <div class="honorBOx_title">ISO9001</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/ISO27001.png" alt="" />
            </div>
            <div class="honorBOx_title">ISO27001</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2021中国企业上云数智化平台服务领军企业.png" alt="" />
            </div>
            <div class="honorBOx_title">2021中国企业上云数智化平台服务领军企业</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/高新技术企业技术.png" alt="" />
            </div>
            <div class="honorBOx_title">高新技术企业技术</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/性能检测报告.png" alt="" />
            </div>
            <div class="honorBOx_title">10万+ 并发性能检测报告</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/博信诚（北京）网络科技有限公司牌匾40-60.jpg" alt="" />
            </div>
            <div class="honorBOx_title">博信诚（北京）网络科技有限公司牌匾</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/新理财 第十七届中国CFO大会.png" alt="" />
            </div>
            <div class="honorBOx_title">新理财 第十七届中国CFO大会</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2022中国业财一体化云服务领航企业.png" alt="" />
            </div>
            <div class="honorBOx_title">2022中国业财一体化云服务领航企业</div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination" id="custom"></div>
      <div class="my-swiper-btn mt-5">
        <div class="swiper-btn button-prev" @click="slideTo('prev')">
        </div>
        <div class="swiper-btn button-next" @click="slideTo('next')">
        </div>
      </div>
    </div>
    <div v-else>
      <swiper
        class="mySwipes"
        :options="swiperOptions"
        ref="videoSwiper"
        
      >
        <swiper-slide>
          <div class="honorBOx">
            <div>
              <img src="@/assets/images/aboutUs/honor/2018中国CFO最佳财务共享服务奖.jpg" alt="" />
            </div>
            <div class="honorBOx_title">2018中国CFO最佳财务共享服务奖</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2021中国领先地智慧企业云平台.jpg" alt="" />
            </div>
            <div class="honorBOx_title">2021中国领先地智慧企业云平台</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/国旅感谢信.jpg" alt="" />
            </div>
            <div class="honorBOx_title">国旅感谢信</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2019中国企业财务共享平台首选品牌厂商奖.png" alt="" />
            </div>
            <div class="honorBOx_title">2019中国企业财务共享平台首选品牌厂商奖</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/CMMI3认证证书.png" alt="" />
            </div>
            <div class="honorBOx_title">CMMI3认证证书</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/ISO9001.png" alt="" />
            </div>
            <div class="honorBOx_title">ISO9001</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/ISO27001.png" alt="" />
            </div>
            <div class="honorBOx_title">ISO27001</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2021中国企业上云数智化平台服务领军企业.png" alt="" />
            </div>
            <div class="honorBOx_title">2021中国企业上云数智化平台服务领军企业</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/高新技术企业技术.png" alt="" />
            </div>
            <div class="honorBOx_title">高新技术企业技术</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/性能检测报告.png" alt="" />
            </div>
            <div class="honorBOx_title">10万+ 并发性能检测报告</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/博信诚（北京）网络科技有限公司牌匾40-60.jpg" alt="" />
            </div>
            <div class="honorBOx_title">博信诚（北京）网络科技有限公司牌匾</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/新理财 第十七届中国CFO大会.png" alt="" />
            </div>
            <div class="honorBOx_title">新理财 第十七届中国CFO大会</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="honorBOx">
            <div class="honorImg">
              <img src="@/assets/images/aboutUs/honor/2022中国业财一体化云服务领航企业.png" alt="" />
            </div>
            <div class="honorBOx_title">2022中国业财一体化云服务领航企业</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<style lang="scss">
.honorSwipe {
  position: relative;
  .honorBOx{
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 20px;
    background: #fff;
    .honorImg{
      flex: 1;
      display: flex;
      align-items: center;
    }
    .honorBOx_title{
      height: 70px;
      border-top: 1px solid #333;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 10px;
      display: none;
    }
  }
  .mySwipe{
    .swiper-wrapper {
      .swiper-slide {
        transform: scale(1);
        transition: all 0.5s ease;
        z-index: 1;
        
        //background: #fff;
        display: flex;
        align-items: center;
        //padding: 0 70px;
        img {
          max-height: 440px;
        }
      }
      .swiper-slide-prev {
        transform: scale(1.15);
        transition: all 0.5s ease;
        z-index: 4;
      }
      .swiper-slide-next {
        transform: scale(1.15);
        transition: all 0.5s ease;
        z-index: 4;
      }
      .swiper-slide-active {
        transform: scale(1.3);
        transition: all 0.5s ease;  
        z-index: 5;
      }
    }
  }
  .mySwipes{
    .swiper-wrapper{
      .honorBOx{
        height: 400px;
        margin: 0 4rem;
      }
    }
  }
  .swiper-pagination {
    span{
      position: relative;
      cursor: pointer;
      &::before{
        content: '';
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -49% 0 0 -50%;
        z-index: 10;
      }
      &::after{
        content: '';
        width: 8px;
        height: 8px;
        background-color: #959595;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -2px 0 0 -4px;
      }
      svg {
        fill: none;
        stroke-width: 2;
        stroke: #005bab;
        stroke-dasharray: 100;
        transform: rotate(-90deg);
        
      }
      &.swipe-pagination-customs-active{
        &::after{
          background-color: #005bab;
        }
      }
    } 
    
    .swipe-pagination-customs {
      margin-left: 20px;
    }
    .swipe-pagination-customs-active {
      animation: slide 5s ease;
    }
    
  }
  @keyframes slide {
    0% {
      stroke-dashoffset: 100;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  .button-prev{
    position: absolute;
    top: 50%;
    left: 5%;
    z-index: 5;
    width: 60px;
    height: 60px;
    opacity: 0.6;
    transform: scale(0.8);
    cursor: pointer;
    background: url("../../../assets/images/aboutUs/btn-L.png") no-repeat;
    &:hover{
      background: url("../../../assets/images/aboutUs/btn-L-H.png") no-repeat center;

    }
  }
  .button-next{
    position: absolute;
    top: 50%;
    right: 5%;
    z-index: 5;
    width: 60px;
    height: 60px;
    opacity: 0.6;
    transform: scale(0.8);
    cursor: pointer;
    background: url("../../../assets/images/aboutUs/btn-R.png") no-repeat;
    &:hover{
      background: url("../../../assets/images/aboutUs/btn-R-H.png") no-repeat center;

    }
  }
}
</style>

<script>
var vm = null
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "honorSwipe",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 1000,
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        clickable: true,
        observer: true,
        observeParents: true,
        // grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          paginationClickable: true,
          autoplayDisableOnInteraction: false,
          type: "custom",
          renderCustom: function (swiper, current, total) {
            var paginationHtml = ""
            for (var i = 0; i < total; i++) {
              if (i === current - 1) {
                paginationHtml +=
                  '<span class="swipe-pagination-customs swipe-pagination-customs-active '+i+'hh" data-index='+i+'><svg width="30" height="30" viewBox="0 0 30 30"><circle id="circle" cx="15" cy="15" r="14" /></svg></span>'
              } else {
                paginationHtml +=
                  '<span class="swipe-pagination-customs '+i+'hh" data-index='+i+'><svg width="30" height="30" viewBox="0 0 30 30"><circle id="circle" cx="15" cy="15" r="14" /></svg></span>'
              }
            }
            return paginationHtml
          },
        },
        on: {
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle()
          },
        },
        navigation:{
          prevButton:'.swiper-button-prev',
          nextButton:'.swiper-button-next',
        },
        
        // autoplayDisableOnInteraction: true,
        // allowTouchMove: true,
        // custom:'',
      },
      swiperOptions:{
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
      },
      windowWidth: document.documentElement.clientWidth,
    }
  },
  created(){
    vm = this
  },
  mounted() {
    this.customBox = document.getElementById("custom")
    this.customBox.addEventListener("click", this.handleClick, false)
    console.log(this.customBox);
  },
  computed: {
  // 获取swiper对象
    swiper () {
      return this.$refs.videoSwiper.swiper
    }
  },
  methods: {
    // handleClick(e) {
    //   // 获取目标元素，拿到目标元素上的 index 值
    //   const current = e.target.dataset.index
    //   console.log(current,'55555');
    //   console.log(this.swiper.activeIndex,'3333');
    //   // 跳转到指定的 swiper 页面
    //   this.swiper.slideTo(current)
    // },
    handleClick(e){
      const current = e.target.dataset.index
      console.log(this.swiper.activeIndex,'3333');
      console.log(current,'55555');
      // this.swiper.slideTo(current)
    },
    slideChangeTransitionStartHandle(){
      // console.log(789);
      // console.log(this.swiper,'3333');
      // console.log(swiper);
    },
    // 自定义单页方法
    slideTo (type) {
      if (type === 'prev') {
        this.swiper.slidePrev()
      } else {
        this.swiper.slideNext()
      }
      setTimeout(() => {
        this.swiper.autoplay.start()
      }, 2000)
    },
  },

  destroyed() {
    // this.customBox.removeEventListener("click", this.handleClick, false)
  },
}
</script>
